<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">绑定</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="addForm" :rules="rules" ref="addForm">
          <el-row>
            <el-col :span="12" class="item">
              <el-form-item label="绑定服务人员" required prop="userName">
                <el-input v-model="addForm.userName" placeholder="请选择服务人员" disabled>
                  <el-button slot="append" icon="el-icon-search" @click="getServe"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="摄像头序列号" required prop="sn">
                <el-input v-model="addForm.sn" placeholder="输入序列号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="摄像头验证码" required prop="yzm">
                <el-input v-model="addForm.yzm" placeholder="输入验证码"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12" class="item">
              <el-form-item label="通道号" required prop="tdh">
                <el-input v-model="addForm.tdh" placeholder="输入通道号"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

        </el-form>

      </div>
      <div class="modal-footer">
        <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
      </div>
    </div>

    <Serve ref="myServe" v-show="showModalServe" v-on:closeServe="showModalServe=false" v-on:setServe="setServe"></Serve>

  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5, hex_md5_with_china} from "@/common/Base64MD5";

import Serve from "./Serve";


export default {
  name: 'Add',
  data() {
    return {
      loading: false,
      showModalServe: false,

      addForm:{
        timeStr:timeStr,
        sign:'',

        userName:'',
        userCode:'',
        sn:'',
        yzm:'',
        tdh:'',

      },

      rules:{
        sn:[
          { required: true, message: '请输入SN号', trigger: 'blur' },
        ],
        userName:[
          { required: true, message: '请选择服务人员', trigger: 'blur' }
        ],
        yzm:[
          { required: true, message: '输入验证码', trigger: 'blur' },
        ],
        tdh:[
          { required: true, message: '输入通道号', trigger: 'blur' },
        ],
      }


    }
  },
  components: {Serve},
  methods: {
    init(){
      this.$refs.addForm.resetFields();
    },

    getServe(){
      this.showModalServe = !this.showModalServe;
      this.$refs.myServe.init();
    },
    setServe(row){
      this.addForm.userCode=row.userCode;
      this.addForm.userName = row.name;
    },


    closeSelf() {
      this.$emit("closeAdd");
    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.addForm.sign = '';
      this.addForm.sign = hex_md5_with_china("jsonStr=" + JSON.stringify(this.addForm) + "&key="+this.$signKey)

      this.$axios({
        method: 'post',
        url: this.$deviceUrl+"DeviceCameraPhilips/Add",
        data: this.addForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }
}


</script>





<style lang="scss" scoped>

</style>
